import type { Client } from '../types/models';
import styles from './Avatar.module.css';

interface AvatarProps {
  client: Pick<Client, 'name' | 'initials' | 'avatarBg' | 'logoUrl'>;
  size?: number;
  fontSize?: string;
}

/** Client avatar: shows the uploaded logo when present, else initials on the
 *  client's gradient tile. */
export function Avatar({ client, size = 40, fontSize = '0.9rem' }: AvatarProps) {
  return (
    <div
      className={styles.avatar}
      style={{
        width: size,
        height: size,
        fontSize,
        background: client.logoUrl ? 'var(--color-bg-tertiary)' : client.avatarBg,
      }}
    >
      {client.logoUrl ? (
        <img src={client.logoUrl} alt={client.name} className={styles.img} />
      ) : (
        client.initials
      )}
    </div>
  );
}
